// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetTeamValueSuggestionsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetTeamValueSuggestionsQuery = { __typename?: 'Query' } & Pick<Types.Query, 'teamValueSuggestions'>;

export const GetTeamValueSuggestionsDocument = /*#__PURE__*/ gql`
    query GetTeamValueSuggestions {
  teamValueSuggestions
}
    `;

/**
 * __useGetTeamValueSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetTeamValueSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamValueSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamValueSuggestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamValueSuggestionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTeamValueSuggestionsQuery, GetTeamValueSuggestionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamValueSuggestionsQuery, GetTeamValueSuggestionsQueryVariables>(
    GetTeamValueSuggestionsDocument,
    options,
  );
}
export function useGetTeamValueSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamValueSuggestionsQuery, GetTeamValueSuggestionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamValueSuggestionsQuery, GetTeamValueSuggestionsQueryVariables>(
    GetTeamValueSuggestionsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetTeamValueSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamValueSuggestionsQuery, GetTeamValueSuggestionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTeamValueSuggestionsQuery, GetTeamValueSuggestionsQueryVariables>;
export function useGetTeamValueSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamValueSuggestionsQuery, GetTeamValueSuggestionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTeamValueSuggestionsQuery | undefined, GetTeamValueSuggestionsQueryVariables>;
export function useGetTeamValueSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTeamValueSuggestionsQuery, GetTeamValueSuggestionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTeamValueSuggestionsQuery, GetTeamValueSuggestionsQueryVariables>(
    GetTeamValueSuggestionsDocument,
    options,
  );
}
export type GetTeamValueSuggestionsQueryHookResult = ReturnType<typeof useGetTeamValueSuggestionsQuery>;
export type GetTeamValueSuggestionsLazyQueryHookResult = ReturnType<typeof useGetTeamValueSuggestionsLazyQuery>;
export type GetTeamValueSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetTeamValueSuggestionsSuspenseQuery>;
